// Single source of truth for the app's deployment sub-path.
//
// Vite's `base` (vite.config.ts) is exposed at runtime as
// import.meta.env.BASE_URL — '/' in local dev, '/ibase/twasta/' in the WildFly
// build. Everything that builds an absolute URL (router basename, API client,
// WebSocket URLs, the SSO bridge fetch) derives from here so the two modes
// share one codebase.

// "/ibase/twasta" in the WildFly build, "" in dev (so existing '/api' paths and
// BrowserRouter basename='' behave exactly as before).
export const APP_BASE = import.meta.env.BASE_URL.replace(/\/$/, '')

// ws(s)://host[/ibase/twasta] — prefix for all WebSocket URLs.
export const WS_BASE = () =>
  `${location.protocol === 'https:' ? 'wss:' : 'ws:'}//${location.host}${APP_BASE}`
